import { IApplicationState } from '../../types/redux';

export const selectShareTooltip = (state: IApplicationState) => state.shareCollection.tooltip;
